import BrandMetrics from './BrandMetrics.View';

export default BrandMetrics;
